var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAury(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.777 2.477c-2.851-.95-7.1-.264-8.87.198 1.69.554 5.077 1.766 5.108 2.177.04.515-.673.317-1.94.436-1.013.095-4.962-.25-6.81-.436l1.703 3.92 2.573.831-1.899.594.674.713h11.284l.514-1.307H20.49l1.979-.831 1.82-3.92c-.317-.396-1.663-1.425-4.514-2.375z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.761 8.772c-.474-.066-1.377-.396-1.187-1.188.238-.99.792-.515 1.188 1.188z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10.908 13.285 1.386 2.257h6.928l1.03-2.257h-9.344z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.747 16.571H12.73l3.087 6.653 2.93-6.652z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.853 8.772c.443.475.607 1.333.634 1.702-1.964 0-2.877 1.267-3.089 1.9.898-.144 2.835-.3 3.405.238.57.539.766 2.178.792 2.93l-7.285.158c.845-1.834 2.7-5.86 3.366-7.284.83-1.782 1.623-.238 2.177.356z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.595 16.571h-7.76l-6.018 12.75L9.404 16.57H2c.211 1.85 1.1 6.09 2.97 8.276 2.335 2.732 6.255 5.701 11.956 5.068 5.7-.634 8.235-3.603 10.175-6.018 1.553-1.932 2.31-5.688 2.495-7.325z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m6.949 10.91 1.78 4.355H2c0-.172.048-.657.238-1.227.237-.713.83-1.307 2.058-2.138.982-.665 2.178-.937 2.653-.99z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAury);
export default __webpack_public_path__ + "static/media/AURY.d6bc214a30dfd9e863ab81734e61c1f3.svg";
export { ForwardRef as ReactComponent };